import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';

import { AUTOPAY_CONTRACTID_STORAGE_KEY } from '../pages/contracts/AutoPayLink';
import { MAKEPAYMENT_CONTRACTID_STORAGE_KEY } from '../pages/make-payment/MakePaymentLink';
import { OPENINVOICES_CONTRACTID_STORAGE_KEY } from '../pages/payments/OpenInvoicesLink';
import { RootState } from '../store';
import { NavigationConfig } from '../utils/navigation-constants';

export const usePendingLinkRedirect = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const isLoggedIn = useSelector((state: RootState) => state.user.isLoggedIn);

    useEffect(() => {
        console.log('[usePendingLinkRedirect] Effect triggered:', { isLoggedIn, pathname: location.pathname });

        if (!isLoggedIn) {
            console.log('[usePendingLinkRedirect] Not logged in, skipping');
            return;
        }

        // Check if we just logged in (we're on a page that's not a link page)
        const isOnLinkPage =
            location.pathname === NavigationConfig.MakePayment ||
            location.pathname === NavigationConfig.AutoPayLink ||
            location.pathname === NavigationConfig.OpenInvoicesLink;

        console.log('[usePendingLinkRedirect] isOnLinkPage:', isOnLinkPage);
        if (isOnLinkPage) {
            console.log('[usePendingLinkRedirect] Already on link page, skipping');
            return; // Already on the right page
        }

        // Check for pending make-payment request
        const pendingMakePaymentId = localStorage.getItem(MAKEPAYMENT_CONTRACTID_STORAGE_KEY);
        console.log('[usePendingLinkRedirect] pendingMakePaymentId:', pendingMakePaymentId);
        if (pendingMakePaymentId) {
            console.log('[usePendingLinkRedirect] Redirecting to make-payment');
            navigate(`${NavigationConfig.MakePayment}?contractID=${encodeURIComponent(pendingMakePaymentId)}`);
            return;
        }

        // Check for pending autopay request
        const pendingAutoPayId = localStorage.getItem(AUTOPAY_CONTRACTID_STORAGE_KEY);
        console.log('[usePendingLinkRedirect] pendingAutoPayId:', pendingAutoPayId);
        if (pendingAutoPayId) {
            console.log('[usePendingLinkRedirect] Redirecting to autopay');
            navigate(`${NavigationConfig.AutoPayLink}?contractID=${encodeURIComponent(pendingAutoPayId)}`);
            return;
        }

        // Check for pending open-invoices request
        const pendingOpenInvoicesId = localStorage.getItem(OPENINVOICES_CONTRACTID_STORAGE_KEY);
        console.log('[usePendingLinkRedirect] pendingOpenInvoicesId:', pendingOpenInvoicesId);
        if (pendingOpenInvoicesId) {
            console.log('[usePendingLinkRedirect] Redirecting to open-invoices');
            navigate(`${NavigationConfig.OpenInvoicesLink}?contractID=${encodeURIComponent(pendingOpenInvoicesId)}`);
            return;
        }

        console.log('[usePendingLinkRedirect] No pending requests found');
    }, [isLoggedIn, location.pathname, navigate]);
};
